import React from "react";
import GlobalHeader from "./GlobalHeader";
import ScreenFallback from "./ScreenFallback";
import QuizHeadline from "./QuizHeadline";
import BodyCopy from "./BodyCopy";
import AdvanceButton from "./AdvanceButton";

class Landing extends React.Component {
  componentDidMount() {
    // this.props.updateClickstream("Landing");
  }

  render() {
    const currentScreen = this.props.currentScreen;
    // const updateLastClick = this.props.updateLastClick;
    // const updateClickstream = this.props.updateClickstream;
    return (
      <div className="screen">
        <div className="screen_content">
          <GlobalHeader
          // updateClickstream={updateClickstream}
          />
          <div className="content_wrapper content_wrapper--landing">
            <QuizHeadline currentScreen={currentScreen} />
            <BodyCopy currentScreen={currentScreen} />
          </div>
          <AdvanceButton
            currentScreen={currentScreen}
            // updateLastClick={updateLastClick}
          />
        </div>
        <ScreenFallback
        // updateClickstream={updateClickstream}
        />
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing.js